"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _actions = require("settings-ui-sdk/Domains/actions");

var _selectors = require("settings-ui-sdk/Domains/selectors");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _selectors3 = require("settings-ui-sdk/Auth/selectors");

var _ContentMembershipSettingsHeader = _interopRequireDefault(require("../components/ContentMembershipSettingsHeader"));

var _routeSelectors = require("../selectors/routeSelectors");

var _getAllDomainsOrDomainNameFromURL = _interopRequireDefault(require("../utils/getAllDomainsOrDomainNameFromURL"));

var ContentMembershipSettingsHeaderContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ContentMembershipSettingsHeaderContainer, _Component);

  function ContentMembershipSettingsHeaderContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentMembershipSettingsHeaderContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentMembershipSettingsHeaderContainer).call(this, props));
    _this.handleSelectedTabChange = _this.handleSelectedTabChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelectedDomainChange = _this.handleSelectedDomainChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContentMembershipSettingsHeaderContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadDomains();
    }
  }, {
    key: "handleSelectedDomainChange",
    value: function handleSelectedDomainChange(evt) {
      var activeTab = this.props.activeTab;
      var domainId = evt.target.value;
      this.props.push(_UrlPathParams.CONTENT_MEMBERSHIP + "/" + domainId + "/" + activeTab);
    }
  }, {
    key: "handleSelectedTabChange",
    value: function handleSelectedTabChange(evt) {
      var selectedDomain = this.props.selectedDomain;
      var tabId = evt.target.value;
      this.props.push(_UrlPathParams.CONTENT_MEMBERSHIP + "/" + selectedDomain + "/" + tabId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeTab = _this$props.activeTab,
          domainOptions = _this$props.domainOptions,
          selectedDomain = _this$props.selectedDomain,
          isAllDomainsSelected = _this$props.isAllDomainsSelected,
          fetchDomainsRequestStatus = _this$props.fetchDomainsRequestStatus,
          hasServiceContentRestrictedWrite = _this$props.hasServiceContentRestrictedWrite,
          hasMembershipTemplatesAccess = _this$props.hasMembershipTemplatesAccess;
      return _react.default.createElement(_ContentMembershipSettingsHeader.default, {
        activeTab: activeTab,
        domainOptions: domainOptions,
        domainOptionsRequestStatus: fetchDomainsRequestStatus,
        onSelectedDomainChange: this.handleSelectedDomainChange,
        onSelectedTabChange: this.handleSelectedTabChange,
        selectedDomain: selectedDomain,
        isAllDomainsSelected: isAllDomainsSelected,
        showTemplatesTab: hasMembershipTemplatesAccess && hasServiceContentRestrictedWrite || hasMembershipTemplatesAccess
      });
    }
  }]);
  return ContentMembershipSettingsHeaderContainer;
}(_react.Component);

ContentMembershipSettingsHeaderContainer.propTypes = {
  activeTab: _react.PropTypes.string.isRequired,
  domainOptions: _react.PropTypes.array.isRequired,
  selectedDomain: _react.PropTypes.string.isRequired,
  push: _react.PropTypes.func.isRequired,
  loadDomains: _react.PropTypes.func.isRequired,
  isAllDomainsSelected: _react.PropTypes.bool.isRequired,
  fetchDomainsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  hasServiceContentRestrictedWrite: _react.PropTypes.bool.isRequired,
  hasMembershipTemplatesAccess: _react.PropTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeTab: (0, _selectors2.getActiveTabIdFromRoute)(state),
    domainOptions: (0, _selectors.getDomainOptionsExcludingInternalDomains)(state),
    selectedDomain: (0, _routeSelectors.getAllDomainsOrDomainNameFromRoute)(state),
    fetchDomainsRequestStatus: (0, _selectors.getFetchDomainsRequestStatus)(state),
    isAllDomainsSelected: (0, _getAllDomainsOrDomainNameFromURL.default)(window.location.href) === _UrlPathParams.ALL_DOMAINS,
    hasServiceContentRestrictedWrite: (0, _selectors3.getHasServiceContentRestrictedWrite)(state),
    hasMembershipTemplatesAccess: (0, _selectors3.getHasMembershipTemplatesAccess)(state)
  };
};

var mapDispatchToProps = {
  push: _reactRouterRedux.push,
  loadDomains: _actions.loadDomains
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentMembershipSettingsHeaderContainer);

exports.default = _default;
module.exports = exports.default;